module.exports = __webpack_public_path__ + "static/media/invite-1.ab16f1c4.jpg";